/* eslint no-param-reassign: ["error", { "props": false }] */

const { AuthServiceMethods, AuthServices, TimeoutLabels } = require('../constants');
const {
  computeExpirationInfos,
  computeExpirationInfosAfterRefresh,
  fetchApi,
  tryToClearTimeout,
} = require('./common');

const receivedToken = (manager, jwt) => {
  manager.jwt = jwt;
};

const refreshToken = async (manager) => {
  const { endpoint, jwt, onTokenRefreshCallback } = manager;

  const res = await fetchApi(endpoint, {
    method: AuthServiceMethods.REFRESH,
    ns: AuthServices.REFRESH,
    params: { token: jwt },
  });

  if (res && res.result) {
    const { expiration_delay: expirationDelay, token: newJWT } = res.result;

    if (expirationDelay && newJWT) {
      // eslint-disable-next-line no-use-before-define
      handleGenerateOrRefreshTokenResponse(manager, newJWT, expirationDelay);
      if (onTokenRefreshCallback) {
        onTokenRefreshCallback(newJWT, expirationDelay);
      }
    }
  }
};

const scheduleRefreshToken = (manager, timeout) => {
  const { timeoutRefs } = manager;

  tryToClearTimeout(timeoutRefs, TimeoutLabels.REFRESH_TOKEN);

  timeoutRefs[TimeoutLabels.REFRESH_TOKEN] = setTimeout(() => {
    refreshToken(manager);
    timeoutRefs[TimeoutLabels.REFRESH_TOKEN] = null;
  }, timeout);
};

const invalidateToken = (manager) => {
  const { onTokenExpireCallback } = manager;
  manager.jwt = null;
  if (onTokenExpireCallback) {
    onTokenExpireCallback();
  }
};

const scheduleInvalidateToken = (manager, expirationDelay) => {
  const { timeoutRefs } = manager;

  tryToClearTimeout(timeoutRefs, TimeoutLabels.INVALIDATE_TOKEN);

  timeoutRefs[TimeoutLabels.INVALIDATE_TOKEN] = setTimeout(() => {
    tryToClearTimeout(timeoutRefs, TimeoutLabels.REFRESH_TOKEN);
    invalidateToken(manager);

    timeoutRefs[TimeoutLabels.INVALIDATE_TOKEN] = null;
  }, expirationDelay * 1000);
};

const handleGenerateOrRefreshTokenResponse = (manager, jwt, expirationDelay) => {
  let refreshTimeout = null;
  let expDelay = expirationDelay;

  if (expirationDelay) {
    ({ refreshTimeout } = computeExpirationInfos(expirationDelay));
  } else {
    ({ refreshTimeout, expirationDelay: expDelay } = computeExpirationInfosAfterRefresh());
  }

  receivedToken(manager, jwt);
  scheduleRefreshToken(manager, refreshTimeout);
  scheduleInvalidateToken(manager, expDelay);

  return { jwt, expirationDelay: expDelay };
};

module.exports = { handleGenerateOrRefreshTokenResponse };
